import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { FORMIK_SELECT_EMPTY_VALUE } from '../../../../../../constants/validation'
import { useElementFocusState } from '../../../../../../hooks'
import { getItemsFromApiResponse } from '../../../../../../utils/api'
import { isValueStringType } from '../../../../../../utils/common'
import { FieldStackedLabel } from '../../../../../Field'
import { FlatSelect } from '../../../../../Flat'
import { FormFieldSelectNG } from '../../../../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../Formik'
import { SymbolCounter } from '../../../../../SymbolCounter'
import {
  REGISTRATION_FORM_FIELD_HEIGHT,
  REGISTRATION_FORM_FIELD_NAME_FLAT,
  REGISTRATION_FORM_FLAT_MAX_LENGTH,
} from '../../RegistrationForm.constants'
import { getOpenDataFlats } from '../RegistrationFormFields.api'
import { getFlatSelectSearchParam } from '../RegistrationFormFields.utils'

function FlatField({ buildingId, disabled, ukId, ...restProps }) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  const { focused, handleBlur, handleFocus } = useElementFocusState()

  const apiParams = {
    buildingId,
    ukId,
  }

  return (
    <FormikField
      {...restProps}
      withEntityCreationFromSearchValue
      Component={FormFieldSelectNG}
      Field={FieldStackedLabel}
      Select={FlatSelect}
      apiParams={apiParams}
      controlProps={{
        contentProps: {
          inputProps: {
            placeholder: t('Auth.SignUpFlatPlaceholderKey'),
          },
        },
        height: REGISTRATION_FORM_FIELD_HEIGHT,
      }}
      disabled={!Number.isSafeInteger(buildingId) || disabled}
      emptyValue={FORMIK_SELECT_EMPTY_VALUE}
      fieldComponentProps={{
        SymbolCounter:
          focused &&
          isValueStringType(values[REGISTRATION_FORM_FIELD_NAME_FLAT])
            ? SymbolCounter
            : null,
        label: t('Auth.SignUpFlatLabelKey'),
        maxLength: REGISTRATION_FORM_FLAT_MAX_LENGTH,
      }}
      getData={getOpenDataFlats}
      getDataItems={getItemsFromApiResponse}
      getErrorProps={getFormikFormFieldErrorProps}
      getSearchApiParam={getFlatSelectSearchParam}
      maxLength={REGISTRATION_FORM_FLAT_MAX_LENGTH}
      name={REGISTRATION_FORM_FIELD_NAME_FLAT}
      tooltip={
        !Number.isSafeInteger(buildingId)
          ? t('Auth.SignUpFlatTooltipSelectBuildingFirstKey')
          : null
      }
      onBlur={handleBlur}
      onFocus={handleFocus}
    />
  )
}

export default FlatField
